import { Link } from "react-router-dom";
import { APP_ROUTES } from "const";
import { ReactComponent as Facebook } from "assets/images/facebook.svg";
import { ReactComponent as Instagram } from "assets/images/instagram.svg";
import { ReactComponent as Twitter } from "assets/images/twitter.svg";

// Editorial Logo Component - matches landing page style exactly
function EditorialLogoFooter() {
  return (
    <Link to={APP_ROUTES.LANDING} className="inline-flex items-baseline">
      <span
        className="text-2xl font-semibold"
        style={{
          color: '#FAF7F2',
          fontFamily: "'Fraunces', serif"
        }}
      >
        WE
      </span>
      <span
        className="text-2xl font-light italic"
        style={{
          color: 'rgba(250, 247, 242, 0.7)',
          fontFamily: "'Fraunces', serif"
        }}
      >
        attitude
      </span>
      <span className="text-xs font-medium" style={{ color: 'rgba(250, 247, 242, 0.4)' }}>.org</span>
    </Link>
  );
}

export function Footer() {
  const footerLinks = [
    { label: 'Issues', href: APP_ROUTES.ISSUES },
    { label: 'Solutions', href: APP_ROUTES.SOLUTION_LIST },
    { label: 'Action Groups', href: APP_ROUTES.ACTION_GROUP_LIST },
  ];

  return (
    <footer
      className="w-full"
      style={{
        background: '#1C1917',
        fontFamily: "'Source Sans 3', sans-serif"
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6">
          {/* Logo and tagline */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <EditorialLogoFooter />
            <p
              className="text-sm text-center md:text-left"
              style={{ color: '#78716C' }}
            >
              Empowering communities worldwide
            </p>
          </div>

          {/* Navigation links */}
          <div className="flex items-center gap-6">
            {footerLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="text-sm transition-colors"
                style={{
                  color: '#A8A29E',
                  fontFamily: "'Source Sans 3', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#FAF7F2';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#A8A29E';
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Social links */}
          <div className="flex items-center gap-4">
            <a
              href="https://facebook.com/weattitude"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full transition-colors"
              style={{ background: 'rgba(168, 162, 158, 0.1)' }}
              aria-label="Facebook"
            >
              <Facebook className="w-4 h-4" style={{ fill: '#A8A29E' }} />
            </a>
            <a
              href="https://instagram.com/weattitude"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full transition-colors"
              style={{ background: 'rgba(168, 162, 158, 0.1)' }}
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" style={{ fill: '#A8A29E' }} />
            </a>
            <a
              href="https://twitter.com/weattitude"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-full transition-colors"
              style={{ background: 'rgba(168, 162, 158, 0.1)' }}
              aria-label="Twitter"
            >
              <Twitter className="w-4 h-4" style={{ fill: '#A8A29E' }} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div
          className="my-6"
          style={{ borderTop: '1px solid rgba(168, 162, 158, 0.2)' }}
        />

        {/* Copyright */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <span
            className="text-xs"
            style={{ color: '#78716C' }}
          >
            {`© ${new Date().getFullYear()} WEattitude.org. All rights reserved.`}
          </span>
          <div className="flex items-center gap-4">
            <a
              href="/privacy"
              className="text-xs transition-colors"
              style={{ color: '#78716C' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#FAF7F2';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#78716C';
              }}
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-xs transition-colors"
              style={{ color: '#78716C' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#FAF7F2';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#78716C';
              }}
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
